module.exports = __webpack_public_path__ + "static/media/m_beard_stiletto_diamond__v_vector.ee0df867.svg";